import { Flex } from '@chakra-ui/react';
import { MdOutlineAccountCircle } from 'react-icons/md';

export function TopBar() {
  return (
    <Flex as="header" align="center" justify="flex-end" bg="#fafafa" h="64px" px="26px">
      <MdOutlineAccountCircle color="#8b8b8b" size="20px" />
    </Flex>
  );
}